import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';
import { LegalFees } from '../../../../models/FlowOfFunds/flow-of-funds.model';

export interface UploadLegalFeesInvoiceRequest {
    engagementId: number;
    file: File;
}

export const UploadLegalFeesInvoice = createAsyncThunk(
    'flowOfFunds/uploadLegalFeesInvoice',
    async (params: UploadLegalFeesInvoiceRequest, dispatch: any) => {
        const axios = dispatch.getState().core.axios;

        try {
            const formData = new FormData();
            formData.append('File', params.file);
            const temporaryFileResponse = await axios.post(
                `/api/temporaryfiles`,
                formData,
                {
                    headers: { 'Content-Type': 'multipart/form-data' },
                }
            );

            if (temporaryFileResponse.status !== 200) {
                throw new Error('Failed to upload the invoice');
            }

            const response = await axios.put(
                `/api/flowOfFunds/${params.engagementId}/legalFees/invoice`,
                {
                    temporaryFileId: temporaryFileResponse.data.id,
                }
            );

            if (response.status !== 200) {
                throw new Error('Failed to save the invoice');
            }

            return response.data as LegalFees;
        } catch (error) {
            createNotification('Could not upload the invoice.', 'error');
            throw error;
        }
    }
);
